import env from './env.json';

export const getEnvConfig = () => {
	const currentEnv = process.env.REACT_APP_ENV || process.env.NODE_ENV;
	const data = currentEnv && env[currentEnv] ? env[currentEnv].EnvironmentConfig : env.production.EnvironmentConfig;
	return {...data, version: process.env.REACT_APP_VERSION, name: 'Tessa App'};
};
